import {pageInfo, getIntEditData, agree, refuse} from '../api';
import {cornSupplier, getAccessoryOrderStatus, approveStatus} from "../../../../../api";

const toExamine = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    intEditObj: null,
    agreeObj: null,
    refuseObj: null,
    accessoryOrderStatusObj: null,
    supplierObj: null,
    approveStatusObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    PLANT(state, data) {
      state.addObj = data;
    },
    INTEDIT_DATA(state, data) {
      state.intEditObj = data.obj;
    },
    AGREE(state, data) {
      state.agreeObj = data;
    },
    REFUSE(state, data) {
      state.refuseObj = data;
    },
    ACCESSORY_ORDER_STATUS(state, data) {
      state.accessoryOrderStatusObj = data;
    },
    SUPPLIER_DATA(state, data) {
      state.supplierObj = data;
    },
    APPROVE_STATUS(state, data) {
      state.approveStatusObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    //初始化
    async getIntEditData({commit}, obj){
      let resp = await getIntEditData(obj);
      commit('INTEDIT_DATA', resp);
    },
    //同意
    async agree({commit}, obj){
      let resp = await agree(obj);
      commit('AGREE', resp);
    },
    //拒绝
    async refuse({commit}, obj){
      let resp = await refuse(obj);
      commit('REFUSE', resp);
    },
    //预约状态
    async getAccessoryOrderStatus({commit}, obj){
      let resp = await getAccessoryOrderStatus(obj);
      commit('ACCESSORY_ORDER_STATUS', resp);
    },
    //供应商
    async cornSupplier({commit}, obj){
      let resp = await cornSupplier(obj);
      commit('SUPPLIER_DATA', resp);
    },
    //审批状态
    async approveStatus({commit}, obj){
      let resp = await approveStatus(obj);
      commit('APPROVE_STATUS', resp);
    },
  }
}
export default toExamine



// WEBPACK FOOTER //
// ./src/page/bd/accessory/toExamine/store/toExamine.store.js